import React, { memo } from "react";
import ReactHlsPlayer from "react-hls-player";
import { ImageSkeleton } from "../../Skeletons/skeletonTemplates";

function CourseThumbnail({ video }) {
  let courseThumbnail;
  if (!video) {
    courseThumbnail = <ImageSkeleton classes="custom-rounded" />;
  } else if (video.video_available) {
    courseThumbnail = (
      <ReactHlsPlayer
        src={video?.link?.replace(".m3u8", "-hlsx720p.m3u8")}
        autoPlay={true}
        controls={true}
        muted
        width="100%"
        height="100%"
      />
    );
  } else
    courseThumbnail = (
      <img
        alt=""
        className="coursesDescriptionImage img-fluid custom-rounded"
        src={video.thumbnail_image}
      />
    );

  return courseThumbnail;
}

export default memo(CourseThumbnail);
